module.exports = __webpack_public_path__ + "img/tgrd_tegridytoken.89aaf2d.png";